module.exports = __webpack_public_path__ + "static/media/card-teytu.8cd7435a.png";